
import { useNavigate, useLocation } from "react-router-dom";
import { TbPackage } from "react-icons/tb";
import React, { useState } from "react";
import { FiLogOut } from "react-icons/fi"; // for logout, optional
import { IoPersonCircleOutline, IoLocationOutline, IoSettingsOutline } from "react-icons/io5";
 
const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const menuItems = [
    {
      icon: <IoPersonCircleOutline size={20} />,
      label: "Profile",
      path: "/profile",
    },
    {
      icon: <TbPackage size={20} />,
      label: "Orders",
      path: "/profile/orders",
    },
    {
      icon: <IoLocationOutline size={20} />,
      label: "My Address",
      path: "/profile/address",
    },
    {
      icon: <IoSettingsOutline size={20} />,
      label: "Settings",
      path: "/profile/settings",
    },
  ];
 
  const handleItemClick = (path) => navigate(path);
  const isActive = (path) => location.pathname === path;
 
  return (
<>
      {/* Desktop Sidebar */}
<aside className="hidden md:block w-[27%] text-sm text-white">
<div className="pt-4 rounded-xl bg-black">
<nav className="flex flex-col items-center mt-4 w-full">
            {menuItems.map((item, index) => (
<button
                key={index}
                onClick={() => handleItemClick(item.path)}
                className={`flex justify-between items-center gap-3 px-5 py-4 w-full max-w-[302px] border-b border-white border-opacity-10 hover:bg-white hover:bg-opacity-5 ${
                  isActive(item.path) ? "bg-white bg-opacity-10" : ""
                }`}
>
<div className="flex items-center gap-3">
                  {item.icon}
<span>{item.label}</span>
</div>
<svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
>
<path
                    d="M6.375 3.91992L11.625 9.16992L6.375 14.4199"
                    stroke="#DED8CC"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
</svg>
</button>
            ))}
 
            {/* Desktop Logout */}
      <button
  onClick={() => setShowLogoutModal(true)}
  className="flex items-center gap-3 px-5 py-4 w-full max-w-[302px] hover:bg-white hover:bg-opacity-5"
>
  <FiLogOut size={20} />
  <span>Log out</span>
</button>

</nav>
</div>
</aside>
 
      {/* Mobile Bottom Navbar */}
<div className="md:hidden fixed bottom-0 left-0 w-full bg-black text-white flex justify-around items-center py-3 z-50 border-t border-gray-700">
        {menuItems.map((item, i) => (
<button
            key={i}
            onClick={() => handleItemClick(item.path)}
            className={`flex flex-col items-center text-xs ${
              isActive(item.path) ? "text-yellow-400" : "text-white"
            }`}
>
<div className="w-6 h-6">{item.icon}</div>
<span className="mt-1">{item.label}</span>
</button>
        ))}
 
        {/* Mobile Logout */}
  <button
  onClick={() => setShowLogoutModal(true)}
  className="flex flex-col items-center text-xs text-white hover:text-yellow-400"
>
  <FiLogOut size={20} />
  <span className="mt-1">Logout</span>
</button>
</div>
{showLogoutModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-white text-black rounded-md shadow-lg w-80 p-6">
      <h2 className="text-lg font-semibold mb-4">Confirm Logout</h2>
      <p className="text-sm mb-6">Are you sure you want to log out?</p>
      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowLogoutModal(false)}
          className="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            localStorage.clear();
            navigate("/login");
          }}
          className="px-4 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700"
        >
          Log out
        </button>
      </div>
    </div>
  </div>
)}

</>
  );
};
 
export default Sidebar;